<template>
  <div class="jiaotongGonggao">
    <div class="container2">
      <div class="tableContent">
        <div class="intableContent">
          <div class="tableHead">
            <div class="left">标题</div>
            <div class="mid">内容</div>
            <div class="right"></div>
          </div>

          <div class="tableBody" v-for="item in contentList" :key="item.id">
            <div class="left">
              <div class="inLeft">
                <div class="leftTitle">
                  {{ item.title }}
                </div>
                <div class="leftTime">{{ item.pubtime | filterTime }}</div>
              </div>
            </div>
            <div class="mid">
              <div class="inMid">
                {{ item.content }}
              </div>
            </div>
            <div class="right">
              <div   @click="addIntegral(item)"
                ><div class="inRight">查看</div>
                <div class="inRight">详情</div></div
              >
            </div>
          </div>

          <!-- <div class="tableBody">
            <div class="left">
              <div class="inLeft">
                <div class="leftTitle">
                  苏州市疫情防控重要工作提示（2021年第7号）
                </div>
                <div class="leftTime">2021-08-18</div>
              </div>
            </div>
            <div class="mid">
              <div class="inMid">
                8月18日19时，上海市松江区永丰街道仓丰路855号（有庐公寓）调整为中风险地区。为有效控制和降低疫情传播风险，现就我市相关防控工作提示看详情。
              </div>
            </div>
            <div class="right">
              <a href="https://mp.weixin.qq.com/s/GBubz_obee8-yN4KrCdZmg"
                ><div class="inRight">查看</div>
                <div class="inRight">详情</div></a
              >
            </div>
          </div>
          <div class="tableBody">
            <div class="left">
              <div class="inLeft">
                <div class="leftTitle">苏州市疫情防控2021年第6号通告</div>
                <div class="leftTime">2021-08-07</div>
              </div>
            </div>
            <div class="mid">
              <div class="inMid">
                当前新冠肺炎疫情防控形势严峻复杂，为从严从紧做好疫情防控工作，落实好“早发现、早报告、早隔离、早治疗”的“四早”措施，有效阻断疫情传播，切实保障市民身体健康和生命安全，经研究，决定暂停销售退热、止咳、抗病毒、抗生素四类药品。
              </div>
            </div>
            <div class="right">
              <a href="https://mp.weixin.qq.com/s/JBAKec0B42g1NywBkQzTxA"
                ><div class="inRight">查看</div>
                <div class="inRight">详情</div></a
              >
            </div>
          </div>
          <div class="tableBody">
            <div class="left">
              <div class="inLeft">
                <div class="leftTitle">苏州市疫情防控2021年第5号通告</div>
                <div class="leftTime">2021-07-31</div>
              </div>
            </div>
            <div class="mid">
              <div class="inMid">
                针对当前日趋严峻复杂的疫情形势，为进一步从严加强疫情常态化防控措施，有效阻止疫情在我市发生，保障广大市民健康安全，现就当前严格疫情防控措施通告如下。
              </div>
            </div>
            <div class="right">
              <a href=" https://mp.weixin.qq.com/s/3E9rdRmmiU69HRo-T_-Edg"
                ><div class="inRight">查看</div>
                <div class="inRight">详情</div></a
              >
            </div>
          </div>
          <div class="tableBody">
            <div class="left">
              <div class="inLeft">
                <div class="leftTitle">苏州市疫情防控2021年第4号通告</div>
                <div class="leftTime">2021-07-28</div>
              </div>
            </div>
            <div class="mid">
              <div class="inMid">
                根据省疫情防控工作领导小组紧急通知，为坚决遏制新冠肺炎疫情传播，全面加大交通防控力度，坚决防止疫情扩散蔓延，尽最大努力减少疫情对全国的影响，现就进一步强化交通疫情防控通告如下
              </div>
            </div>
            <div class="right">
              <a href="https://mp.weixin.qq.com/s/qpXtH6NCounQBIRz-7uPgQ"
                ><div class="inRight">查看</div>
                <div class="inRight">详情</div></a
              >
            </div>
          </div>
          <div class="tableBody">
            <div class="left">
              <div class="inLeft">
                <div class="leftTitle">苏州市疫情防控2021年第3号通告</div>
                <div class="leftTime">2021-07-21</div>
              </div>
            </div>
            <div class="mid">
              <div class="inMid">
                当前全球新冠肺炎疫情仍然严峻复杂，国内部分地区时有小规模疫情发生。7月20日，南京市新冠肺炎疫情防控指挥部通报在南京禄口国际机场工作人员定期核酸检测报告阳性结果。为切实做好我市新冠肺炎疫情常态化防控工作，保障广大市民的身体健康和生命安全，现通告如下
              </div>
            </div>
            <div class="right">
              <a href="https://mp.weixin.qq.com/s/6coFZz1GAwKUNQRlpHwhJQ"
                ><div class="inRight">查看</div>
                <div class="inRight">详情</div></a
              >
            </div>
          </div>
          <div class="tableBody">
            <div class="left">
              <div class="inLeft">
                <div class="leftTitle">苏州市疫情防控2021年第2号通告</div>
                <div class="leftTime">2021-05-15</div>
              </div>
            </div>
            <div class="mid">
              <div class="inMid">
                5月13日以来，安徽省六安市、合肥市和辽宁省营口市连续报告新增新冠肺炎确诊病例。为切实做好我市新冠肺炎疫情常态化防控工作，巩固疫情防控成果，保障广大市民的身体健康和生命安全，现通告如下
              </div>
            </div>
            <div class="right">
              <a href="https://mp.weixin.qq.com/s/OjopHeJaxv5U_kHNDyol8A"
                ><div class="inRight">查看</div>
                <div class="inRight">详情</div></a
              >
            </div>
          </div>
          <div class="tableBody">
            <div class="left">
              <div class="inLeft">
                <div class="leftTitle">苏州市疫情防控2021年第1号通告</div>
                <div class="leftTime">2021-01-15</div>
              </div>
            </div>
            <div class="mid">
              <div class="inMid">
                为做好全市春节期间新冠肺炎疫情防控，切实落实属地、部门、单位和个人“四方责任”，巩固来之不易的疫情防控成果，全力维护广大市民的身体健康和生命安全，现通告如下
              </div>
            </div>
            <div class="right">
              <a href="https://mp.weixin.qq.com/s/ePerIf3V29hA9RAOZqmm7g"
                ><div class="inRight">查看</div>
                <div class="inRight">详情</div></a
              >
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import { Swipe, SwipeItem } from "vant";
import { Tabbar, TabbarItem } from "vant";
import { Tab, Tabs } from "vant";
import { Popup } from "vant";
import { Overlay } from "vant";
Vue.use(Overlay);

Vue.use(Popup);

Vue.use(Tab);
Vue.use(Tabs);

Vue.use(Tabbar);
Vue.use(TabbarItem);

Vue.use(Swipe);
Vue.use(SwipeItem);
import { doRem } from "../utils/setrem";
import { Dialog } from "vant";
export default {
  mounted() {

    this.getInfo();
    document.querySelector("body").setAttribute("style", "overflow:hidden;");
    this.getHeight();
  },
  destroyed() {
    document.querySelector("body").setAttribute("style", "overflow:auto; ");
  },
  filters: {
    filterTime: function (value) {
      let time = new Date(value);
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let date = time.getDate();
      let hours = time.getHours();
      let minute = time.getMinutes();
      let second = time.getSeconds();

      if (month < 10) {
        month = "0" + month;
      }
      if (date < 10) {
        date = "0" + date;
      }
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (second < 10) {
        second = "0" + second;
      }
      return year + "-" + month + "-" + date;
    },
  },
  data() {
    return {
      NavList: [],
      contentList: [],
      inContentList: [],
      current: 0,
      FabuPopup: false,
      show: false,
      loading: false,
      img: "../assets/images/noAddr.png",
    };
  },
  methods: {
    addIntegral(item){
      this.$apis.CmsInterface.addIntegral(this.$axios, {
        type: 1,
        creditDesc: "阅读-疫情通报",
      }).finally(()=>{
        let a= document.createElement('a');
        a.href = item.addressurl;
        a.click();
      });
      // alert('记录')
      
    },
    getHeight() {
      let a = window.screen.availHeight;

      let b =
        document.querySelector(".tableContent").offsetTop -
        document.documentElement.scrollTop;
      document.querySelector(".tableContent").style.height = a - b + "px";
    },
    getYMDHMS(timestamp) {
      let time = new Date(timestamp);
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let date = time.getDate();
      let hours = time.getHours();
      let minute = time.getMinutes();
      let second = time.getSeconds();

      if (month < 10) {
        month = "0" + month;
      }
      if (date < 10) {
        date = "0" + date;
      }
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (second < 10) {
        second = "0" + second;
      }
      return year + "-" + month + "-" + date;
    },
    getInfo() {
      this.$axios
        .get("/appapi/cmsInterface/getPlagueData")
        .then((res) => {
          console.log(res);
          if (res.data.result != 1) {
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result == 1) {
            console.log(res);
            res.data.data.forEach((item) => {
              this.contentList.push(item);
            });
          }
        })
        .catch((err) => {
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.container2 {
  padding-top: 3.4375rem;
  background-color: #ffffff;
  background-image: url("../assets/images/bolangbg.png");
  background-repeat: no-repeat;
  background-size: 100% 13rem;
  .tableContent {
    background-color: #ffffff;
    padding: 1.875rem 2rem 25rem 2rem;
    overflow: auto;
    border-radius: 1rem;

    .tableHead {
      display: flex;
      height: 3.625rem;
      border: 1px solid #e3e3e3;
      .left {
        width: 10.5rem;
        text-align: center;
        line-height: 3.625rem;
        color: #555555;
        font-size: 1.75rem;
        font-weight: bold;
        border-right: 1px solid #e3e3e3;
      }
      .mid {
        width: 25.875rem;
        text-align: center;
        line-height: 3.625rem;
        color: #555555;
        font-size: 1.75rem;
        font-weight: bold;
        border-right: 1px solid #e3e3e3;
      }
      .right {
        flex-grow: 1;
      }
    }
    .tableBody {
      display: flex;
      border: 1px solid #e3e3e3;
      border-top: none;

      .left {
        width: 10.5rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-right: 1px solid #e3e3e3;
        .inLeft {
          .leftTitle {
            color: #19212a;
            font-size: 1.75rem;
            padding: 0 0.5rem 0 1rem;
          }
          .leftTime {
            color: #878787;
            font-size: 1.375rem;
            text-align: center;
            margin-top: 0.5rem;
          }
        }
      }
      .mid {
        width: 25.875rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-right: 1px solid #e3e3e3;
        .inMid {
          color: #555555;
          font-size: 1.75rem;
          padding: 2.125rem 1.375rem 2.25rem 1.125rem;
        }
      }
      .right {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .inRight {
          color: #338989;
          font-size: 1.75rem;
          text-align: center;
        }
      }
    }
  }
}
</style>
